
import React from 'react';
import { Sparkles } from 'lucide-react';

interface LevelXPDisplayProps {
  xpEarned: number;
  showRestartButton: boolean;
  isPracticeMode: boolean;
}

const LevelXPDisplay = ({ 
  xpEarned, 
  showRestartButton, 
  isPracticeMode 
}: LevelXPDisplayProps) => {
  // Don't show XP in practice mode
  if (isPracticeMode) return null;
  
  // Don't show XP when restart button is shown
  if (showRestartButton) return null;

  return (
    <div className="flex items-center justify-center gap-2 mb-2">
      <Sparkles className="h-5 w-5 text-yellow-400" />
      <span className="font-semibold text-lg">+{xpEarned} XP earned!</span>
    </div>
  );
};

export default LevelXPDisplay;
